// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2GMRM","sendOtp":"AuthorizeToLogin_sendOtp__2YSc2"};